import styled, { css } from 'styled-components';

const Card = styled.div`
  background-color: ${props => props.theme.colors.background.card};
  border-radius: ${props => props.theme.borderRadius.lg};
  padding: ${props => props.theme.spacing.lg};
  box-shadow: ${props => props.theme.shadows.md};
  border: 1px solid ${props => props.theme.colors.border};
  transition: transform ${props => props.theme.transitions.medium}, box-shadow ${props => props.theme.transitions.medium};
  margin-bottom: ${props => props.theme.spacing.lg};
  position: relative;
  overflow: hidden;
  
  /* Gradient border effect */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, ${props => props.theme.colors.primary}, ${props => props.theme.colors.accent});
  }
  
  /* Hover animation */
  ${props => props.hoverable ? css`
    &:hover {
      transform: translateY(-5px);
      box-shadow: ${props.theme.shadows.lg};
    }
  ` : ''}
  
  /* Card types */
  ${props => props.variant === 'outlined' ? css`
    background-color: transparent;
    border: 1px solid ${props.theme.colors.border};
  ` : props.variant === 'elevated' ? css`
    box-shadow: ${props.theme.shadows.lg};
  ` : props.variant === 'glow' ? css`
    box-shadow: 0 0 20px ${props.theme.colors.primaryAlpha(0.3)};
    &:hover {
      box-shadow: 0 0 30px ${props.theme.colors.primaryAlpha(0.5)};
    }
  ` : ''}
  
  /* Card title */
  h2, h3 {
    margin-top: 0;
    color: ${props => props.theme.colors.text.primary};
    position: relative;
    display: inline-block;
    margin-bottom: ${props => props.theme.spacing.md};
    font-weight: 600;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 40px;
      height: 2px;
      background: linear-gradient(90deg, ${props => props.theme.colors.primary}, ${props => props.theme.colors.accent});
      border-radius: ${props => props.theme.borderRadius.sm};
    }
  }
`;

// Card Header, Body, and Footer components
export const CardHeader = styled.div`
  margin-bottom: ${props => props.theme.spacing.md};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardBody = styled.div`
  margin-bottom: ${props => props.theme.spacing.md};
`;

export const CardFooter = styled.div`
  margin-top: ${props => props.theme.spacing.md};
  padding-top: ${props => props.theme.spacing.md};
  border-top: 1px solid ${props => props.theme.colors.border};
`;

export default Card; 